import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { IUniversalSelectOption } from '@feathr/components';
import { UniversalSelect } from '@feathr/components';

import { formatTypefaceOptionLabel } from './TypefaceSelect.formatters';

interface IProps {
  onChange: (typeface: string) => void;
  value: string;
}

function TypefaceSelect({ onChange, value }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  // Options are based on browser safe fonts.
  const options = [
    {
      id: 'FK Grotesk',
      name: t('System default (FK Grotesk)'),
    },
    {
      id: 'Arial',
      name: t('Arial'),
    },
    {
      id: 'Verdana',
      name: t('Verdana'),
    },
    {
      id: 'Georgia',
      name: t('Georgia'),
    },
    {
      id: 'Times New Roman',
      name: t('Times New Roman'),
    },
    {
      id: 'Tahoma',
      name: t('Tahoma'),
    },
    {
      id: 'Trebuchet MS',
      name: t('Trebuchet MS'),
    },
    {
      id: 'Roboto',
      name: t('Roboto'),
    },
    {
      id: 'Lato',
      name: t('Lato'),
    },
    {
      id: 'Montserrat',
      name: t('Montserrat'),
    },
  ];

  const selectedOption = options.find((option) => option.id === value);

  function handleSelect({ id }: IUniversalSelectOption): void {
    onChange(id);
  }

  return (
    <UniversalSelect<IUniversalSelectOption>
      formatOptionLabel={formatTypefaceOptionLabel}
      label={t('Typeface family')}
      name={'font-select'}
      onSelectSingle={handleSelect}
      options={options}
      placeholder={t('Select a font...')}
      value={selectedOption}
    />
  );
}

export default TypefaceSelect;
